import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Comments from "./Comments";

const Refundprocess = ({
  selectedRow,
  setSelectedRow,
  setRefundProcessTab,
  getAllRefunds,
  setOpenTab,
  setActiveItem = { setActiveItem },
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const refundStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.refundStatus;
  const fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  const transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  const [refundResponse, setRefundResponse] = useState(null);
  const [getBookingDetails, setGetBookingDetails] = useState(null);
  const [getVehicleDetails, setGetVehicleDetails] = useState(null);
  const [bookingTransaction, setbookingTransaction] = useState(null);
  const [transactiondetails, settransactiodetails] = useState({});
  const [selectedTransactions, setSelectedTransactions] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectedTxnId, setSelectedTxnId] = useState(null);
  const [view, setView] = useState(null); // which row is open
  const [details, setDetails] = useState({}); // { rowId: razorPayDetails }
  const [loadingId, setLoadingId] = useState(null);
  const [bookingComments, setBookingComments] = useState([]);
  const [showComments, setShowComments] = useState(true);

  const rows = Array.isArray(refundResponse?.refundLinks)
    ? refundResponse?.refundLinks
    : refundResponse?.refundLinks
      ? [refundResponse?.refundLinks]
      : [];

  const transactionDetailsInput = [
    {
      label: "Transaction Code",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncode",
    },
    {
      label: "Transaction Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionmode",
    },
    {
      label: "Refundable Amount",
      type: "text",
      isEnable: true,
      placeholder: "",
      value: "refundableamount",
    },
    // {
    //   label: "Attachments",
    //   type: "file",
    //   isEnable: false,
    //   placeholder: "",
    //   value: "attachments",
    // },
  ];

  const getRefundDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/bookingrefunds/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data) {
        setRefundResponse(data?.entityValue);
        // await getVehicleDetailsFromApi(refundResponse?.vehicleId);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getBookingDetailsFromApi = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        getRefundLinksDetails(data?.entityValue?.id);
        setGetBookingDetails(data?.entityValue);
        await getVehicleDetailsFromApi(data?.entityValue?.vehicleId);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  // const bookingTransactionDetails = async (id) => {
  //   let val = "";
  //   if (
  //     selectedRow?.refundStatus === "Processed"
  //   ) {
  //     console.log("IF")
  //     val = "bookingtransactions";
  //   } else if (
  //     selectedRow?.refundStatus === "Pending"
  //   ) {
  //     console.log("ELSE")
  //     val = "refundtransactions";
  //   }
  //   if (!val) {
  //     console.error("Invalid refund status:", selectedRow?.refundStatus);
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`${apiUrl}/api/${val}?bookingId=${id}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });
  //     const data = await response.json();
  //     if (data) {
  //       setbookingTransaction(data?.entities?.rows || []);
  //     }
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching transactions:", error);
  //   }
  // };

  const getVehicleDetailsFromApi = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setGetVehicleDetails(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getBookingComments = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingcomments?limit=1000&bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        const sorted = data.entities.rows.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        );

        setBookingComments(sorted);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncode" && /^\d+$/.test(value)) {
      errorMsg = "* Accepts only letters";
    }
    if (key === "refundableamount" && !/^\d+(\.\d+)?$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "transactionmode" && !/^[a-zA-Z\s]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets and space";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleInputChange = (key, event) => {
    const value =
      event?.target?.value !== undefined ? event.target.value : event;

    settransactiodetails((prev) => ({
      ...prev,
      [key]: value,
    }));
    validateField(key, value);
  };

  const handleSave = async () => {
    let isValid = true;
    const newErrors = {};

    // Required fields

    const requiredFields = [
      "refundableamount",
      "transactioncode",
      "transactionmode",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }
    const refundStatusCode = refundStatus?.inverted?.bookingClosed;
    try {
      const response = await fetch(`${apiUrl}/api/bookingrefunds`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          refundTransactionsList: {
            bookingId: refundResponse?.bookingId,
            bookingCode: getBookingDetails?.bookingCode,
            transactionCode: transactiondetails?.transactioncode,
            amount: refundResponse?.refundableAmount,
            paymentMode: transactiondetails?.transactionmode,
            refundId: refundResponse?.id,
          },
          id: selectedRow?.id,
          refundStatus: refundStatus?.inverted?.processed,
          bookingObject: {
            id: getBookingDetails?.id,
            bookingStatus:
              String(getBookingDetails?.bookingStatus) !==
                String(fleetBookingStatus?.inverted?.cancelled)
                ? fleetBookingStatus?.inverted?.bookingClosed
                : null,
          },
          postBookingObject: {
            bookingId: getBookingDetails?.id,
            statusId: refundStatus?.inverted?.processed,
            statusText: "Refund Processed",
          },
        }),
      });
      const data = await response.json();
      if (data) {
        setSelectedRow(null);
        setRefundProcessTab(false);
        getAllRefunds();
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const generateRefundLinks = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/refundlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          bookingId: getBookingDetails?.id,
          refundIdInternal: refundResponse?.id,
          bookingCode: refundResponse?.bookingCode,
          paymentId: selectedTransactions?.transactionCode,
          amount: String(refundResponse?.refundableAmount * 100),
          paymentMode: selectedTransactions?.paymentMode,
          refundObject: {
            refundTransactionsList: {
              bookingId: getBookingDetails?.id,
              bookingCode: refundResponse?.bookingCode,
              transactionCode: selectedTransactions?.transactionCode,
              amount: refundResponse?.refundableAmount,
              paymentMode: selectedTransactions?.paymentMode,
              refundId: refundResponse?.id,
            },
            id: refundResponse?.id,
            refundStatus: refundStatus?.inverted?.processed,
            bookingObject: {
              id: getBookingDetails?.id,
              bookingStatus: fleetBookingStatus?.inverted?.bookingClosed,
            },
          },
        }),
      });
      const data = await response.json();
      if (data) {
        setGetVehicleDetails(data?.entityValue);
        getRefundDetails(selectedRow?.id);
        setSelectedRow(null);
        setRefundProcessTab(false);
        getAllRefunds();
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (selectedTransactions?.amount) {
      settransactiodetails((prev) => ({
        ...prev,
        transactioncode: selectedTransactions?.transactionCode,
        transactionmode: selectedTransactions?.paymentMode,
        refundableamount: refundResponse?.refundableAmount,
      }));
    }
  }, [selectedTransactions]);

  useEffect(() => {
    if (refundResponse?.bookingId) {
      getBookingDetailsFromApi(refundResponse?.bookingId);
    }
  }, [refundResponse]);

  useEffect(() => {
    if (refundResponse) {
      settransactiodetails((prev) => ({
        ...prev,
        refundableamount: refundResponse?.refundableAmount,
      }));
    }
  }, [refundResponse]);

  useEffect(() => {
    if (selectedRow?.id) {
      getRefundDetails(selectedRow?.id);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (getBookingDetails?.id) {
      getBookingComments(getBookingDetails.id);
    }
  }, [getBookingDetails]);

  const [getRefundLinksDetailData, setRefundLinksDetaisData] = useState(null);

  const getRefundLinksDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/refundlinks?bookingId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data) {
        setRefundLinksDetaisData(data?.entityValue?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const viewRazorPayDetails = async (id) => {
    setLoadingId(id);
    try {
      const response = await fetch(`${apiUrl}/api/refundlinks/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.entityValue) {
        setDetails((prev) => ({
          ...prev,
          [id]: data.entityValue,
        }));
      }
    } catch (error) {
      console.error("Error fetching RazorPay details:", error);
    } finally {
      setLoadingId(null);
    }
  };

  const bookingTransactions = Array.isArray(refundResponse?.bookingTransactions)
    ? refundResponse.bookingTransactions
    : refundResponse?.bookingTransactions
      ? [refundResponse.bookingTransactions]
      : [];

  const refundBreakupList = Array.isArray(refundResponse?.refundBreakupList)
    ? refundResponse.refundBreakupList
    : refundResponse?.refundBreakupList
      ? [refundResponse.refundBreakupList]
      : [];

  return (
    <div>
      <div className="md:p-6 h-screen overflow-y-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <div className="flex justify-between">
          <h2 className="text-xl md:text-2xl font-bold text-gray-700 mb-4">
            Booking Refund Details
          </h2>

          <button
            onClick={() => {
              setSelectedRow(null);
              setRefundProcessTab(false);
            }}
            class="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
            type="button"
          >
            <div class="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                height="25px"
                width="25px"
              >
                <path
                  d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                  fill="#000000"
                ></path>
                <path
                  d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                  fill="#000000"
                ></path>
              </svg>
            </div>
            <p class="translate-x-2">Go Back</p>
          </button>
        </div>

        <div className="bg-gray-50 shadow-lg rounded-xl p-6 border border-blue-100 mt-8">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left">
              <img
                src={getVehicleDetails?.imageUrl}
                alt="Car"
                className="w-56 h-56 object-cover rounded-lg shadow-md mb-4"
              />
              <div className="space-y-2 text-sm">
                <p>
                  <span className="font-semibold text-gray-600">
                    Registration Number:
                  </span>{" "}
                  <span className="text-gray-800">
                    {getVehicleDetails?.licensePlate || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Vehicle Name:
                  </span>{" "}
                  <span className="text-gray-800">
                    {getVehicleDetails?.name || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Fuel Type:
                  </span>{" "}
                  <span className="text-gray-800">
                    {fuelType[getVehicleDetails?.fuelType] || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-semibold text-gray-600">
                    Transmission:
                  </span>{" "}
                  <span className="text-gray-800">
                    {transmissionType[getVehicleDetails?.transmissionType] ||
                      "N/A"}
                  </span>
                </p>
                <p className="bg-red-300 p-4 rounded-lg">
                  <span className="font-bold text-gray-600">
                    Booking Type:
                  </span>{" "}
                  <span className="text-gray-800">
                    {bookingTypes[getBookingDetails?.bookingType] ||
                      "N/A"}
                  </span>
                </p>
              </div>
            </div>

            <div className="flex-[2] grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 text-sm">
              <p>
                <span className="font-semibold text-gray-600">Booking ID:</span>{" "}
                <span
                  onClick={() => {
                    setActiveItem("View all Bookings");
                    setOpenTab(false);
                    navigate(
                      `/viewallbookings?bookingid=${getBookingDetails?.bookingCode}&display=true`,
                    );
                  }}
                  className="text-blue-800 cursor-pointer underline"
                >
                  {getBookingDetails?.bookingCode || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">Start Date:</span>{" "}
                <span className="text-gray-800">
                  {formatDateAndTime(getBookingDetails?.bookFrom) || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">End Date:</span>{" "}
                <span className="text-gray-800">
                  {formatDateAndTime(getBookingDetails?.bookTo) || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">Status:</span>{" "}
                <span className="uppercase text-xs font-bold text-blue-600">
                  {selectedRow?.refundStatus || "N/A"}
                </span>
              </p>
              {/* <p>
                <span className="font-semibold text-gray-600">City:</span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.city || "N/A"}
                </span>
              </p> */}
              <p>
                <span className="font-semibold text-gray-600">
                  Total Booking Hrs:
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.bookingHrs || "N/A"} Hrs
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">City :</span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.cityText || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Delivery Address :
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.deliveryAddress || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Pickup Address :
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.pickupAddress || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Overall Free Kms:
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.overallFreeKm || "N/A"} Kms
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Customer Name:
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.customerName || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Customer Email:
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.customerEmail || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Customer Number:
                </span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.customerMobile || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-semibold text-gray-600">
                  Refunded Initiated By:
                </span>{" "}
                <span className="text-gray-800">
                  {refundResponse?.refundByDetails?.name || "N/A"}
                </span>
              </p>
              <p className="bg-yellow-200 font-semibold p-2 rounded-lg w-full">
                <span className="font-semibold text-gray-600">
                  Refundable Amount:
                </span>{" "}
                <span className="text-gray-800">
                  {"₹ " + refundResponse?.refundableAmount || "N/A"}
                </span>
              </p>
              {/* <p className="bg-green-200 font-semibold p-2 rounded-lg w-full">
                <span className="font-semibold text-gray-600">Updated By:</span>{" "}
                <span className="text-gray-800">
                  {getBookingDetails?.updatedBy || "N/A"}
                </span>
              </p>
              <p className="bg-green-200 font-semibold p-2 rounded-lg w-full">
                <span className="font-semibold text-gray-600">Updated At:</span>{" "}
                <span className="text-gray-800">
                  {formatDateAndTime(getBookingDetails?.updatedAt) || "N/A"}
                </span>
              </p> */}
            </div>
          </div>
        </div>

        <div className="mt-8">
          <button
            onClick={() => setShowComments(!showComments)}
            className="w-full rounded-t-lg bg-gray-800 text-white px-5 py-4 flex items-center justify-between"
          >
            <h1 className="text-xl font-semibold">Booking Comments</h1>

            {showComments ? (
              <VisibilityIcon className="cursor-pointer" />
            ) : (
              <VisibilityOffIcon className="cursor-pointer" />
            )}
          </button>

          {showComments && (
              <Comments
                bookingComments={bookingComments}
                setBookingComments={setBookingComments}
                getBookingComments={getBookingComments}
                summaryDetails={{
                  id: getBookingDetails?.id,
                  inquiryCode: getBookingDetails?.inquiryCode,
                  bookingCode: getBookingDetails?.bookingCode,
                }}
              />
          )}
        </div>

        <h1 className="text-xl font-semibold mt-8">Refund Breakup List</h1>
        <div className="overflow-auto rounded-lg shadow bg-white mt-8">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-4">S.No</th>
                <th className="p-4">Type</th>
                <th className="p-4">Created At</th>
                <th className="p-4">Amount</th>
              </tr>
            </thead>
            <tbody>
              {refundBreakupList?.map((item) => (
                <>
                  <tr key={item?.id} className="border-b hover:bg-gray-50">
                    <td className="p-4">{item?.id}</td>
                    <td className="p-4">{item?.typeText || "-"}</td>
                    <td className="p-4">
                      {formatDateAndTime(item?.createdAt) || "-"}
                    </td>
                    <td className="p-4">{"₹ " + item?.amount}</td>
                  </tr>
                </>
              ))}
              {refundResponse?.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center p-4 text-gray-500">
                    No Refund found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {selectedRow?.refundStatus === "Pending" ? (
          <>
            <h1 className="text-xl font-semibold mt-8">Transaction Details</h1>
            <div className="overflow-auto rounded-lg shadow bg-white mt-8">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="p-4">Id</th>
                    <th className="p-4">Payment Mode</th>
                    <th className="p-4">Transaction Code</th>
                    <th className="p-4">Amount Collected</th>
                    <th className="p-4">Created At</th>
                    {selectedRow?.refundStatus === "Pending" && (
                      <th className="p-4">Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {bookingTransactions.map((item) => (
                    <tr key={item?.id} className="border-b hover:bg-gray-50">
                      <td className="p-4">{item?.id}</td>
                      <td className="p-4">{item?.paymentMode || "-"}</td>
                      <td className="p-4">{item?.transactionCode || "-"}</td>
                      <td className="p-4">{"₹ " + item?.amount}</td>
                      <td className="p-4">{item?.createdAt}</td>
                      {selectedRow?.refundStatus === "Pending" &&
                        item?.transactionCode?.includes("pay") && (
                          <td className="p-4">
                            <button
                              onClick={() => {
                                setSelectedTxnId(item?.id);
                                setSelectedTransactions(item);
                              }}
                              // className="bg-blue-500 text-white w-40 h-12 text-lg rounded-lg"
                              className={`rounded-lg p-1 w-20 text-lg h-8 ${selectedTxnId === item.id
                                ? "bg-green-500 text-white"
                                : "bg-blue-500 text-white"
                                }`}
                            >
                              {selectedTxnId === item.id
                                ? "Selected"
                                : "Select"}
                            </button>
                            {selectedTxnId === item.id && (
                              <button
                                onClick={() => {
                                  setSelectedTxnId(null);
                                  setSelectedTransactions(null);
                                  settransactiodetails((prev) => ({
                                    ...prev,
                                    transactioncode: "",
                                    transactionmode: "",
                                    refundableamount:
                                      refundResponse?.refundableAmount,
                                  }));
                                }}
                                // className="bg-blue-500 text-white w-40 h-12 text-lg rounded-lg"
                                className={`rounded-lg p-1 w-20 text-lg h-8 bg-red-500 text-white mx-2`}
                              >
                                Unselect
                              </button>
                            )}
                          </td>
                        )}
                    </tr>
                  ))}

                  {bookingTransactions.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center p-4 text-gray-500">
                        No Refund found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold mt-8">
              Refunded Transactions
            </h1>
            <div className="overflow-auto rounded-lg shadow bg-white mt-8">
              <table className="min-w-full text-sm text-left">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="p-4">Refund Id</th>
                    <th className="p-4">Amount</th>
                    <th className="p-4">Paynment Mode</th>
                    <th className="p-4">Transaction Code</th>
                    <th className="p-4">Transaction Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b hover:bg-gray-50">
                    <td className="p-4">
                      {refundResponse?.refundTransactions?.id}
                    </td>
                    <td className="p-4">
                      {refundResponse?.refundTransactions?.amount || "-"}
                    </td>
                    <td className="p-4">
                      {refundResponse?.refundTransactions?.paymentMode}
                    </td>
                    <td className="p-4">
                      {refundResponse?.refundTransactions?.transactionCode}
                    </td>
                    <td className="p-4">
                      {refundResponse?.refundTransactions?.transactionDate}
                    </td>
                  </tr>

                  {bookingTransactions.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center p-4 text-gray-500">
                        No Refund found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        <h1 className="text-xl font-semibold mt-8">Online Refund Details</h1>
        {selectedRow?.refundStatus === "Processed" && (
          <div className="overflow-auto rounded-lg shadow bg-white mt-8">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-800 text-white">
                <tr>
                  <th className="p-4">ID</th>
                  <th className="p-4">Refund Id</th>
                  <th className="p-4">Status</th>
                  <th className="p-4">Created at</th>
                  <th className="p-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((row) => (
                    <React.Fragment key={row.id}>
                      <tr className="border-b">
                        <td className="p-4">{row.id}</td>
                        <td className="p-4">{row.refundId}</td>
                        <td className="p-4">{row.status}</td>
                        <td className="p-4">{row.createdAt}</td>
                        <td className="p-4">
                          <button
                            onClick={() => {
                              if (view === row.id) {
                                setView(null);
                              } else {
                                setView(row.id);
                                // fetch only if not already loaded
                                if (!details[row.id])
                                  viewRazorPayDetails(row.id);
                              }
                            }}
                            className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 text-sm"
                          >
                            {view === row.id ? "Hide" : "View"}
                          </button>
                        </td>
                      </tr>

                      {view === row.id && (
                        <tr className="bg-gray-50">
                          <td colSpan={5} className="p-4">
                            {loadingId === row.id ? (
                              <p>Loading details...</p>
                            ) : details[row.id] ? (
                              <div className="text-gray-700">
                                <p>
                                  <strong>Refund Id:</strong>{" "}
                                  {details[row.id].refundId}
                                </p>
                                <p>
                                  <strong>Status:</strong>{" "}
                                  {details[row.id].status}
                                </p>
                                <p>
                                  <strong>Created At:</strong>{" "}
                                  {details[row.id].createdAt}
                                </p>
                                <p>
                                  <strong>Speed At:</strong>{" "}
                                  {details[row.id].speedProcessed}
                                </p>
                                <p>
                                  <strong>Currency:</strong>{" "}
                                  {details[row.id].currency}
                                </p>
                              </div>
                            ) : (
                              <p className="text-gray-500">No details found</p>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="p-4 text-center text-gray-500">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {selectedRow?.refundStatus === "Pending" && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 mt-8">
              {transactionDetailsInput.map((input, index) => (
                <div key={index}>
                  <TextField
                    fullWidth
                    type={input.type}
                    label={input.label}
                    disabled={input?.isEnable}
                    value={transactiondetails[input.value] || ""}
                    // onChange={(e) =>
                    //   settransactiodetails((prev) => ({
                    //     ...prev,
                    //     [input.value]: e.target.value,
                    //   }))
                    // }
                    error={!!errors[input.value]}
                    helperText={errors[input.value]}
                    onChange={(event) =>
                      handleInputChange(input.value, event.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
              ))}
            </div>

            <div className="flex justify-end gap-4 mt-4">
              <button
                disabled={!selectedTxnId ? true : false}
                onClick={() => {
                  generateRefundLinks();
                }}
                className={`${!selectedTxnId
                  ? "opacity-50 cursor-not-allowed hover:opacity-90"
                  : ""
                  } cursor-pointer text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 via-sky-500 to-pink-500 bg-[length:400%] rounded-[30px] hover:animate-gradient-xy`}
              >
                + Online Refund
              </button>

              <button
                disabled={selectedTxnId ? true : false}
                onClick={handleSave}
                className={`${selectedTxnId
                  ? "opacity-50 cursor-not-allowed hover:opacity-90"
                  : ""
                  }relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 rounded-full hover:opacity-90`}
              >
                + Save
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Refundprocess;
